module.exports = __webpack_public_path__ + "img/parking.5cd572ff.png";